import { AUTH_STORAGE_KEY } from 'ui/types'

interface ParsedAuth {
  id?: number
  entityId?: number
}

const parseAuth = (raw: string | null): ParsedAuth => {
  if (!raw) return {}
  try {
    const parsed = JSON.parse(raw)
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      !Array.isArray(parsed)
    ) {
      return parsed as ParsedAuth
    }
    return {}
  } catch {
    return {}
  }
}

// Embedded contexts (an iframe or the Upduo webview) share this origin's
// localStorage with every other embedded instance, and each instance clears
// and rewrites the auth key during its own UPDUO_AUTH handshake. Reacting to
// those sibling writes would reload an iframe whose wrapper has already sent
// auth once — and the wrapper does not re-send on a later UPDUO_READY, so the
// reloaded iframe hangs on the embedded boot gate forever. Identity changes
// in embedded mode arrive explicitly via UPDUO_AUTH / UPDUO_LOGOUT instead.
const isEmbeddedContext = (): boolean =>
  typeof window !== 'undefined' &&
  (window.parent !== window || typeof (window as any).Upduo !== 'undefined')

export const shouldReloadOnAuthChange = (e: StorageEvent): boolean => {
  if (e.key !== AUTH_STORAGE_KEY) return false
  if (isEmbeddedContext()) return false

  const oldAuth = parseAuth(e.oldValue)
  const newAuth = parseAuth(e.newValue)

  return oldAuth.id !== newAuth.id || oldAuth.entityId !== newAuth.entityId
}
